$(document).ready(function () {
    $('br').attr('aria-hidden', 'true');
    $('hr').attr('aria-hidden', 'true');
    //fix multiple form issue
    // $('.product__variant-options .button--variant input').removeAttr('id');
    // $('.product__variant-options .button--variant label').removeAttr('for');
    // $(document).on('click', '.button--variant', function() {
    //     // Find the radio input inside this specific button and check it
    //     const $input = $(this).find('input[type="radio"]');
        
    //     if (!$input.prop('checked')) {
    //         $input.prop('checked', true).trigger('change');
    //     }
    // });
});



//Empty Heading issue Fixed
$(document).ready(function () {
    $('h1, h2, h3, h4, h5, h6').each(function () {
        var $heading = $(this);
        if ($.trim($heading.text()).length === 0 && $heading.children('br').length === $heading.children().length) {
            $heading.remove();
        }
    });
});

//External links
$(document).ready(function () {
    $('a[href^="http://"], a[href^="https://"]').each(function () {
        const $link = $(this);

        const currentHost = window.location.hostname.replace('www.', '');
        const linkHost = this.hostname.replace('www.', '');

        // Skip internal links
        if (linkHost === currentHost || !linkHost) return;

        const warningText = 'opens in a new tab';

        let ariaLabel = $link.attr('aria-label');

        // Case 1: aria-label exists but warning is missing
        if (ariaLabel) {
            if (!ariaLabel.toLowerCase().includes(warningText)) {
                ariaLabel = `${ariaLabel} - ${warningText}`;
                $link.attr('aria-label', ariaLabel);
            }
        } else {
            // Case 2: aria-label does not exist, build one
            const imgAlt = $link.find('img[alt]').first().attr('alt') || '';

            const visibleText = $link
                .clone()
                .children()
                .remove()
                .end()
                .text()
                .trim();

            const labelParts = [];

            if (imgAlt) labelParts.push(imgAlt);
            if (visibleText) labelParts.push(visibleText);

            labelParts.push(warningText);

            ariaLabel = labelParts.join(' - ');
            $link.attr('aria-label', ariaLabel);
        }

        // Apply external link behavior
        $link.attr({
            'title': ariaLabel,
            'target': '_blank',
            'rel': 'noopener noreferrer'
        });

        $link.addClass('external-link');
    });
});


// List of Email aria label assigned
$(document).ready(function () {

    $('a[href^="mailto:"]').each(function () {

        let email = $(this).attr('href').replace('mailto:', '').trim();


        if (email) {

            email = decodeURIComponent(email)
                .split('?')[0]
                .split('&')[0];

            const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
            if (emailRegex.test(email)) {
                $(this).attr('aria-label', 'Email Address: ' + email);
            } else {

                console.warn('Invalid email address:', email);
            }
        }
    });
});

// Label For Phone Numbers
$(document).ready(function () {
    $('a[href^="tel:"]').each(function () {
        const telNumber = $(this).attr('href').replace('tel:', ''); // Remove "tel:" prefix
        const ariaNumber = telNumber.replace(/-/g, '.'); // Replace hyphens with dots
        $(this).attr('aria-label', `Phone Number: ${ariaNumber}`);
    });
});

$(document).ready(function () {
    function cleanSwiperAttrs() {
        $('.swiper-slide[role="group"]').removeAttr('role aria-label');
    }

    // Run once
    cleanSwiperAttrs();

    // Run again after slide change (if Swiper is active)
    if (typeof Swiper !== 'undefined') {
        setInterval(cleanSwiperAttrs, 1000); // fallback approach
    }
});

$(document).ready(function() {
    function updatePaginationAccessibility() {
      $('.hero__swiper-pagination').each(function() {
        const isHidden = $(this).attr('aria-hidden') === 'true';
        $(this).find('.swiper-pagination-bullet').attr('tabindex', isHidden ? '-1' : '0');
      });
    }

    // Initialize
    updatePaginationAccessibility();
});

document.querySelectorAll('.js-submenu-toggle').forEach(button => {
    const submenu = document.getElementById(button.getAttribute('aria-controls'));
    const parentItem = button.closest('.js-nav-item');
  
    button.addEventListener('click', () => {
      const isOpen = button.getAttribute('aria-expanded') === 'true';
  
      // Close all other menus
      document.querySelectorAll('.js-submenu-toggle').forEach(btn => {
        btn.setAttribute('aria-expanded', 'false');
      });
      document.querySelectorAll('.js-dropdown').forEach(menu => {
        menu.classList.remove('is-visible');
        menu.setAttribute('hidden', '');
      });
  
      // Toggle current
      if (!isOpen) {
        button.setAttribute('aria-expanded', 'true');
        submenu.classList.add('is-visible');
        submenu.removeAttribute('hidden');
  
        // Move focus to first link
        const firstLink = submenu.querySelector('a');
        if (firstLink) firstLink.focus();
      }
    });
  
    // ESC KEY SUPPORT
    submenu.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        button.setAttribute('aria-expanded', 'false');
        submenu.classList.remove('is-visible');
        submenu.setAttribute('hidden', '');
  
        // Return focus to toggle
        button.focus();
      }
    });
  });

  document.querySelectorAll('input.product-option__input').forEach((el, i) => {
  let oldId = el.getAttribute('id');
  if (!oldId) return;

  let newId = oldId + '-safe-' + i;

  // update input id
  el.setAttribute('id', newId);

  // update matching label
  const label = document.querySelector('label[for="' + oldId + '"]');
  if (label) {
    label.setAttribute('for', newId);
  }
});